import cx from "classnames";
import React from "react";

import { Anchor } from "@/components/elements/Anchor";
import { Icon } from "@/components/elements/Icon";
import { Text } from "@/components/elements/Text";
import { PageLink } from "@/types/types";

import styles from "./styles.module.css";

export type ButtonBackProps = {
  copy?: string;
  label?: string;
  className?: string;
} & (
  | {
      onClick: () => void;
      pageLink?: never;
    }
  | {
      onClick?: never;
      pageLink: PageLink;
    }
);

export const ButtonBack = ({
  onClick,
  copy,
  pageLink,
  label = "back",
  className,
}: ButtonBackProps) => {
  const containerClass = cx(styles.container, className);
  const content = (
    <>
      <Icon type="chevron_left" label={label} />
      {copy && (
        <Text size="xs" className={styles.copy}>
          {copy}
        </Text>
      )}
    </>
  );

  if (pageLink) {
    return (
      <Anchor className={containerClass} pageLink={pageLink}>
        {content}
      </Anchor>
    );
  }

  return (
    <button
      className={containerClass}
      aria-label={label}
      onClick={onClick}
      type="button"
    >
      {content}
    </button>
  );
};
